import { useContext } from 'react';
import { DesktopContext } from '../context/IsDesktop';

export const useIsDesktop = () => {
  const desktopContext = useContext(DesktopContext);
  return desktopContext.isDesktop;
};
